module.exports = __webpack_public_path__ + "img/about-us-title.25e6606d.png";